
import { Component, Input, signal, ViewEncapsulation } from '@angular/core';
import { ScoutingSearchResultOverview } from '../../models/ScoutingSearchResultOverview';

import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-report-search-result-overview',
    imports: [MatExpansionModule, MatAccordion, MatIconModule, MatButtonModule],
    templateUrl: './report-search-result-overview.component.html',
    styleUrl: './report-search-result-overview.component.css',
    encapsulation: ViewEncapsulation.None
})
export class ReportSearchResultOverviewComponent {

  @Input() ResultOverview: ScoutingSearchResultOverview;
  readonly panelOpenState = signal(false);
  

}
